import DailyDose from "@/assets/images/adcelerate/channels/daily-dose-of-internet.png";
import DidYouKnow from "@/assets/images/adcelerate/channels/did-you-know.png";
import Nadina from "@/assets/images/adcelerate/channels/nadina-lona.png";
import QuoteSVG from "@/assets/svg/quote.svg";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import startTypewriter from "@/utils/typewriterAnimation";
import { useEffect } from "react";

export default function WhoDoWeDoItFor() {
  const { ref, isVisible } = useScrollReveal();

  const reviews = [
    {
      feedback:
        "The best network with incredible support, fast payments and lots of payment methods.",
      thumbnail: DidYouKnow,
      channelName: "Did you know?",
      subscriber: "2.5 M",
    },
    {
      feedback: (
        <>
          <span className="font-bold">Enfinity</span> is completely professional
          in every way. Never had any issues
        </>
      ),
      thumbnail: DailyDose,
      channelName: "Daily Dose of Internet",
      subscriber: "20.5 M",
    },
    {
      feedback:
        "Very responsive and helpful. No more copyright infringements, just extra revenue.",
      thumbnail: Nadina,
      channelName: "Nadina Iona",
      subscriber: "1.86 M",
    },
  ];

  useEffect(() => {
    startTypewriter({
      elementId: "whoDoWeDoItForTypewriter",
      words: ["WHO WE DO IT FOR", "WE DO IT FOR YOU"],
    });
  }, []);

  return (
    <div
      ref={ref}
      id="who-do-we-do-it-for"
      className={`${
        isVisible ? "bounce-up" : ""
      } flex flex-col justify-center py-20 lg:py-28 xl:py-32 lg:w-[80%] mx-auto items-center relative overflow-hidden rounded-[20px] animate-slide-up will-change-transform 4xl:max-w-[100rem] space-y-14`}
    >
      <h1 className="adce-hero font-bold text-4xl md:text-6xl text-primary text-center lg:text-left px-8 lg:px-0">
        <span id="whoDoWeDoItForTypewriter"></span>
        <span className="border-r-8 border-primary animate-pulse ml-1"></span>
      </h1>

      <p className="text-base max-w-2xl text-center lg:text-left px-8 lg:px-0">
        Adcelerate (an official distribution brand of Enfinity Limited) provides
        services to a combined creator pool of over 3,500 influencers. Amongst
        those creators are top names like Unbox Therapy, Justin Flom — the #1
        most-viewed Shorts creator of all time — and many more.
      </p>

      {/* Infinite scroll row */}
      <div className="relative overflow-hidden w-full">
        <div className="flex">
          {[1, 2, 3].map((dup) => (
            <section
              key={dup}
              className="scroll-section-left pb-1"
              style={{ "--speed": "15000ms" }}
            >
              {reviews.map((review, index) => (
                <div
                  key={index}
                  className="p-6 shadow bg-white space-y-8 w-96 mx-2 rounded-[20px]"
                >
                  <img src={QuoteSVG} className="mb-4" alt="Quote" />

                  {review.feedback}

                  <div className="flex items-center gap-4 w-full">
                    <img
                      src={review.thumbnail}
                      className="w-14 h-14"
                      alt="Channel Thumbnail"
                    />
                    <div>
                      <p className="font-bold">{review.channelName}</p>
                      <p>{review.subscriber} Subscribers</p>
                    </div>
                  </div>
                </div>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
